<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Tipos de Identificación</h4>
    <hr />

    <DataTable
      :data="tipoidens"
      :columns="columnas"
      idField="idTipoIden"
      mensajeVacio="No hay tipos de identificación registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idTipoIden)"
      @view="row => abrirEditar(row.idTipoIden)"
      @delete="row => deleteTipoIden(row.idTipoIden)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoIden.idTipoIden"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoIden.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarTipoIden"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarTipoIden"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "TipoIdenList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      tipoidens:      [],
      datoTipoIden:   {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Nombre", field: "nombre" },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwtipoidens")
        .then(r => { this.tipoidens = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar tipos de identificación:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwtipoidens/nombre/" + nombre)
        .then(r => { this.tipoidens = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar tipo de identificación:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoTipoIden,
        ["nombre"],
        ["Nombre"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarTipoIden() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/tipoidens", this.datoTipoIden);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tipo de identificación creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarTipoIden() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/tipoidens", this.datoTipoIden);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tipo de identificación actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteTipoIden(idTipoIden) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar tipo de identificación?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/tipoidens/" + idTipoIden);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoTipoIden = {};
      this.titulo       = "Crear Tipo de Identificación";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idTipoIden) {
      this.modalWindow = true;
      this.titulo      = "Editar Tipo de Identificación";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwtipoidens/" + idTipoIden);
        this.datoTipoIden = resp.data;
      } catch (e) {
        console.error("Error al cargar tipo de identificación:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idTipoIden) {
      if (idTipoIden != null) this.$router.push("/tipoidenmd/" + idTipoIden);
    },
  },
};
</script>